import styles from './PageAuth.module.css';
import '../../resources/css/admin_style.css';
import React, {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../utils/modal/ModalProvider";
import {IAM_SERVER_SERVICE, IAM_SERVER_SERVICE_PAGE, IAM_SERVER_SERVICE_PAGEAUTH} from "../../utils/Config";
import axios from "../../utils/api/axios";
import DetailModal from "../../utils/modal/DetailModal";
import {PageDetailModal} from "./modal/PageDetailModal";
import {PageRegisterModal} from "./modal/PageRegisterModal";
import {PageAuthRegisterModal} from "./modal/PageAuthRegisterModal";
import PermissionTable from './component/PermissionTable';
import { useServiceList } from '../../utils/service/serviceList';
import { useSelectedService } from '../../utils/contextapi/ServiceProvider';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaPlus, FaMinus, FaSearch } from 'react-icons/fa';
import pageAuthStyles from './modal/PageAuthRegister.module.css';
import { InnocodeButton, InnocodeList, useDialog, useInnocodeLoadingOverlay, useModal } from '@intsoft/innocode-core';

/**
 * 페이지 권한 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function PageAuth({isMobile, setMovePage}) {
    const {openModal} = useContext(ModalContext);
    const { showDialog } = useDialog();
    const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay();
    const { showInnocodeModal } = useModal();

    const [isMobileWindow, setIsMobileWindow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const { selectedService, setSelectedService } = useSelectedService();

    //페이지 데이터, 선택 페이지
    const [treeData, setTreeData] = useState([]);
    const [selectedPage, setSelectedPage] = useState(null);
    //선택 페이지 권한 목록
    const [originalPermissions, setOriginalPermissions] = useState([]); // 최초 서버에서 받아온 권한 리스트(수정 전)
    const [selectedPermissions, setSelectedPermissions] = useState([]); // 화면에서 수정 중인 권한 리스트(수정 후)

    //---- 그룹트리 ----//
    const [showGroupTree, setShowGroupTree] = useState(true);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [expandedNodes, setExpandedNodes] = useState({}); // 확장된 노드들을 관리

    useEffect(() => {
        // setMovePage("[pageAuth]");
    }, []);

    useEffect(() => {
        if (selectedService) {
            fetchData();
        } 
    }, [selectedService]);

    // 데이터 테이블 조회 API
    const fetchData = async () => {
        showLoading();

        try {
             if (selectedService) {
                const url = IAM_SERVER_SERVICE_PAGE + "/get/groups/tree?linkServiceId="+selectedService.serviceId;

                console.info("selectedServiceId",selectedService);

                //페이지의 페이징 조회 
                axios.get(url)
                    .then((res) => {
                    
                        const { data } = res.data;
                        const transformed = transformToTreeData(data);
                        setTreeData(transformed);

                        // setTotalPages(recordsTotal);
                        // setCellData(data);
                    });
            }
        } catch (error) {
            console.error(error);
        } finally {
            hideLoading();
        }
    }

    const transformToTreeData = (data) => {
        return data.map(item => ({
            title: item.pageName,   // 👈 트리에 표시될 텍스트
            key: item.pageId.toString(), // 고유한 키 (문자열 추천)
            children: item.children ? transformToTreeData(item.children) : []
        }));
    };


    const handleSelect = (node) => {
        setSelectedPage(node);
        getPageAuthAll(node.key);
    };

    const toggleExpand = (nodeKey) => {
        setExpandedNodes(prev => ({
            ...prev,
            [nodeKey]: !prev[nodeKey]
        }));
    };

    const handleDetailClick = (node, e) => {
        e.stopPropagation(); // 페이지 선택 방지
        handleDetailInfo(node);
    };


    const getPageAuthAll = (id) => {
                //page 권한 상세 정보 조회
        const pageAuthAll = IAM_SERVER_SERVICE_PAGEAUTH + "/get/authAll/" + id;
        axios.get(pageAuthAll)
            .then((pageAuthRes) => {

                //배열을 map/JSON 방식으로 복사하여 완전히 새 객체로 만들어야 서로 영향을 주지 않습니다.
                setOriginalPermissions(pageAuthRes.data.data.map(item => ({ ...item })));
                setSelectedPermissions(pageAuthRes.data.data.map(item => ({ ...item })));

                    })
            .catch((e) => {
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "실패",
                    message: "권한 정보 조회에 실패했습니다.",
                    confirmText: "확인",
                });
            })
    };

    // 권한만 다시 가져오는 함수
    const reloadPageAuth = (pageId) => {
        getPageAuthAll(pageId);
    }
    

    // 페이지 권한 추가 모달 핸들러
    const handleAddPermission = () => {
        showInnocodeModal({
            enableDefaultStyle: true,
            enableMobileFullScreen: false,
            headerBuilder: () => { return <></>; },
            contentBuilder: (
                _data,
                _handleSave,
                _handleDelete,
                _handleUpdate,
                handleClose,
                _modalType
            ) => {
                return <PageAuthRegisterModal 
                    update={reloadPageAuth} 
                    selectedServiceId={selectedService.serviceId} 
                    pageId={selectedPage.key}
                    onClose={handleClose}
                />;
            },
        });
    };

    // 페이지 권한 저장 모달 핸들러
    const handleSavePermission = () => {

        if (!selectedPermissions.length) {
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "실패",
                message: "저장할 권한이 없습니다.",
                confirmText: "확인",
            });
            return;
        }

        showDialog({
            iconType: "warning",
            type: 'confirm',
            title: "권한 저장 확인",
            message: "권한을 저장 하시겠습니까?",
            confirmText: "예",
            cancelText: "아니요",
            onConfirm: () => {
                // 변경된 권한만 추출
                const changedPermissions = selectedPermissions.filter(updated => {
                    const original = originalPermissions.find(origin => origin.authorityDetailId === updated.authorityDetailId);
                    if (!original) return false;
                    return (
                        original.create !== updated.create ||
                        original.read !== updated.read ||
                        original.update !== updated.update ||
                        original.delete !== updated.delete
                    );
                });

                if (changedPermissions.length === 0) {
                    showDialog({
                        iconType: "check",
                        type: 'info',
                        title: "알림",
                        message: "변경된 내용이 없습니다.",
                        confirmText: "확인",
                    });
                    return;
                }

                // // 변경된 항목만 저장(axios 여러 번, 또는 일괄 저장 API 사용)
                const promises = changedPermissions.map(permission =>
                    axios.post(`${IAM_SERVER_SERVICE_PAGEAUTH}/update`, permission)
                );

                Promise.all(promises)
                    .then(() => {
                        showDialog({
                            iconType: "check",
                            type: 'info',
                            title: "성공",
                            message: "권한이 저장되었습니다.",
                            confirmText: "확인",
                        });
                        // 필요시 새로고침
                        reloadPageAuth(selectedPage.key);
                    })
                    .catch(err => {
                        showDialog({
                            iconType: "warning",
                            type: 'error',
                            title: "실패",
                            message: err.response?.data?.message || "저장 실패",
                            confirmText: "확인",
                        });
                    });
            },
        });
    };

    // 콜백 함수
    const handlePermissionChange = (updatedPermissions) => {
        setSelectedPermissions(updatedPermissions); //  부모에서 직접 상태 업데이트
    };


    // 페이지 상세정보 모달 핸들러
    const handleDetailInfo = (node) => {
        const modalContent = <PageDetailModal id={node.key} update={fetchData}/>
        const modalOption = {modalTitle: '페이지 정보'}
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    // 재귀적으로 트리 노드를 렌더링하는 함수
    const renderTreeNode = (node, level = 0) => {
        const hasChildren = node.children && node.children.length > 0;
        const isExpanded = expandedNodes[node.key];
        const isSelected = selectedPage?.key === node.key;

        return (
            <div key={node.key} style={{ marginLeft: level > 0 ? '33px' : '0' }}>
                <InnocodeList
                    size="sm"
                    className={`${styles.treeNode} ${isSelected ? styles.selected : ''}`}
                    onClick={() => handleSelect(node)}
                    leadingIcon={hasChildren}
                    trailingIcon={true}
                >
                    {hasChildren && (
                        <div 
                            slot="leading-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpand(node.key);
                            }}
                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        >
                            {isExpanded ? 
                             <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
                             <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                           </svg>
                            : 
                                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                              </svg>
                              
                            }
                        </div>
                    )}
                    
                    <span className={styles.treeName}>{node.title}</span>
                    
                    <div 
                        slot="trailing-icon"
                        onClick={(e) => handleDetailClick(node, e)}
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#666' }}
                    >
                        <FaSearch size={14} />
                    </div>
                </InnocodeList>
                
                {/* children 렌더링 */}
                {hasChildren && isExpanded && (
                    <div className={styles.treeChildren}>
                        {node.children.map(child => renderTreeNode(child, level + 1))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={styles.layoutWrapper}>
            <h3>페이지 권한 관리</h3>
            {/* <div className={styles.toggleButtonWrapper}>
                <InnocodeButton
                    size="sm"
                    theme="opacity"
                    designType="alternative"
                    iconOnly={true}
                    onClick={() => setShowGroupTree(!showGroupTree)}
                    icon={showGroupTree ? <FaAngleDoubleLeft size={24} /> : <FaAngleDoubleRight size={24} />}
                />
            </div> */}

            <div className={styles.contentsWrapper}>
                {showGroupTree && (
                    <div className={styles.sidebar}
                        style={{ 
                            marginRight: "10px",
                            width: !isMobileWindow ? "280px" : "120px",
                            minWidth: !isMobileWindow ? "250px" : "100px"
                        }}
                    >
                        <div className={styles.treeWrapper}>
                            {treeData.map(node => renderTreeNode(node))}
                        </div>
                    </div>
                )}
                <div className={styles.contentBox}>
                    <div className={styles.permissionPanel}>
                        {selectedPage ? (
                            <PermissionTable 
                                permissions={selectedPermissions}
                                onPermissionChange={handlePermissionChange}
                                handleAddPermission={handleAddPermission}
                                onReload={() => reloadPageAuth(selectedPage.key)}
                            />
                        ) : (
                            <div className={styles.emptyState}>
                                <p>페이지를 선택해주세요</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageAuth;